<template>
    <article class="a-as-article-header">
        <h3 class="a-as-article-header__title">
            {{ headerData.title }}
        </h3>
        <div class="a-as-article-header__date">
            {{ headerData.date }}
        </div>
    </article>
</template>

<script>
    export default {
        name: 'ArticleHeader',
        props: {
            headerData: Object,
        },
    }
</script>